// extracted by mini-css-extract-plugin
export default {"container":"ShareModalContent_container__EeQie","section":"ShareModalContent_section__0y1DJ","heading":"ShareModalContent_heading__BGAji"};